import { MinusCircle } from 'lucide-react'

export default {
	icon: MinusCircle,
	name: 'Sign Out',
	featured: false,
	onClick: ({ router: _router, onClose, logout }: any) => {
		logout()
		onClose()
	},
	filter: ({ loggedIn }: any) => {
		return loggedIn
	}
}
